import api from './axiosApi'
import type { UserSummary } from './shares'

export type HierarchyLevel = 'DIVISION' | 'DEPARTMENT' | 'CLASS' | 'SUBCLASS'

export interface HierarchyShareRead {
  id: string
  node_id: string
  level: HierarchyLevel
  user: UserSummary | null
  shared_by: UserSummary | null
  shared_at: string
}

export interface HierarchySharesResponse {
  data: HierarchyShareRead[]
}

export interface HierarchyShareCreateBody {
  user_ids: string[]
}

/**
 * Share a hierarchy node with users via POST /hierarchies/{node_id}/shares
 */
export async function shareHierarchyNode(
  nodeId: string,
  body: HierarchyShareCreateBody
): Promise<HierarchySharesResponse> {
  const response = await api.post<HierarchySharesResponse>(
    `/hierarchies/${nodeId}/shares`,
    body
  )
  return response.data
}

/**
 * Get hierarchy node shares via GET /hierarchies/{node_id}/shares
 */
export async function getHierarchyNodeShares(
  nodeId: string
): Promise<HierarchySharesResponse> {
  const response = await api.get<HierarchySharesResponse>(
    `/hierarchies/${nodeId}/shares`
  )
  return response.data
}

/**
 * Remove hierarchy node shares via DELETE /hierarchies/{node_id}/shares
 */
export async function unshareHierarchyNode(
  nodeId: string,
  body: { user_ids: string[] }
): Promise<void> {
  await api.delete(`/hierarchies/${nodeId}/shares`, {
    data: body,
  })
}
